import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from '@mui/material/Alert';

interface ToastConfig {
  variant?: AlertColor;
  message: string;
}

interface DialogsAndToastsContextValues {
  showToast: (config: ToastConfig) => void;
  hideToast: () => void;
}

export const DialogsAndToastsContext = React.createContext<DialogsAndToastsContextValues>({
  showToast: () => null,
  hideToast: () => null,
});

interface Props {
  children: React.ReactNode;
}

export const DialogsAndToastsProvider = ({ children }: Props) => {
  const [toastConfig, setToastConfig] = useState<ToastConfig | null>(null);

  const showToast = (config: ToastConfig) => {
    setTimeout(() => setToastConfig(config), 0);
  };

  const hideToast = () => {
    setTimeout(() => setToastConfig(null), 0);
  };

  return (
    <DialogsAndToastsContext.Provider
      value={{
        showToast,
        hideToast,
      }}
    >
      {children}

      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={!!toastConfig}
        autoHideDuration={null}
        onClose={hideToast}
      >
        <Alert
          onClose={hideToast}
          severity={toastConfig?.variant || 'warning'}
          sx={{ width: '100%' }}
        >
          {toastConfig?.message}
        </Alert>
      </Snackbar>
    </DialogsAndToastsContext.Provider>
  );
};
